import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { gameService } from '@/services/game';
import useVuelidate from '@vuelidate/core';
import { helpers, integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useGameVariantAdd() {
    const router = useAppRouter();

    const model = reactive({
        variantId: null,
        name: '',
        minPlayer: null,
        maxPlayer: null,
        hasTeam: false
    });

    const validations = {
        variantId: { required, integer, minValue: minValue(0) },
        name: { required },
        minPlayer: { required, integer, minValue: minValue(0) },
        maxPlayer: {
            required,
            validateConfirmPlayer: helpers.withMessage(
                'Max player must be greater than or equal min player',
                (value: number, vm: any) => value >= vm.minPlayer
            )
        }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () =>
            gameService.variant.create(model.variantId, model.name, model.minPlayer, model.maxPlayer, model.hasTeam),
        onSuccess: () => router.push({ name: ROUTE_NAME_GAME.VARIANT.INDEX })
    });

    return { model, v$, create };
}
